<template>
  <v-text-field
    ref="textFieldRef"
    :class="`base-input-field pa-0 ${isFocusedClass}`"
    v-bind="$attrs"
    persistent-placeholder
    @update:model-value="propagateInputChange"
    @focus="() => (isFocused = true)"
    @blur="() => (isFocused = false)"
  >
    <template v-for="(_, name) in $slots as {}" #[name]>
      <slot :name="name" />
    </template>
  </v-text-field>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { VTextField } from 'vuetify/components'
const textFieldRef = ref()
const isFocused = ref(false)
const isFocusedClass = computed(() => {
  if (!isFocused.value) return ''
  return 'focused'
})


const testDropdown = [
  { value: 1, title: 'some' },
  { value: 2, title: 'done' }
]
const $slots = defineSlots<Record<string, any>>()
const emit = defineEmits(['input'])
const propagateInputChange = (currentValue: string) => emit('input', currentValue)

defineExpose({
  validate: () => textFieldRef?.value?.validate?.(),
  resetValidation: () => textFieldRef?.value?.resetValidation?.()
})
</script>
